<template>
  <div :class="$style.baseField">
    <van-field
      @click.stop="clickInput"
      :key="name"
      :type="item.type || 'text'"
      v-model.trim="value"
      v-validate="item.rules"
      :name="name"
      :class="item.label.length == 0 && $style.label"
      :maxlength="item.maxlength"
      :show-word-limit="item.limit"
      :label="item.label"
      :label-width="labelWidth"
      :placeholder="item.placeholder"
      :error="error"
      :readonly="readonly"
      :disabled="disabled"
      :focused="showKeyboard"
      @blur="blurInput"
      @input="onInput"
      :left-icon="item.leftIcon"
      :right-icon="item.rightIcon"
      @focus.stop="foucusInput"
      @click-right-icon.stop="onRightIcon"
    >
      <slot name="button" slot="button" />
    </van-field>
  </div>
</template>

<script>
import FORM_DATA from "@/constants/FORM_DATA";

export default {
  name: "BaseField",
  inject: ["$validator"],
  props: {
    name: String,
    error: { type: Boolean, default: false },
    labelWidth: { type: String, default: "2em" },
    initValue: { type: [String, Number], default: "" },
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return { value: "", FORM_DATA: FORM_DATA, showKeyboard: false };
  },
  mounted() {
    if (this.initValue != undefined) {
      this.value = this.initValue;
      this.$emit("map", this.value);
    }
    this.setPasswordIcon();
  },
  computed: {
    item() {
      return FORM_DATA[this.name];
    }
  },
  watch: {
    initValue() {
      if (this.initValue != undefined) {
        this.value = this.initValue;

        this.$emit("map", this.value);
      }
    },
    showKeyboard: {
      handler: function(val) {
        this.$emit("focus", val, this.name);
      }
    }
  },
  methods: {
    blurInput() {
      this.showKeyboard = false;
    },
    /**
     * @description 点击input 聚焦状态变为true
     */
    foucusInput() {
      this.showKeyboard = true;
    },
    /**
     * @description 点击整行Input
     */
    clickInput() {
      this.name != "appealNumber" && this.$emit("iconEvent");
    },
    /**
     * @description 初始化密码图标
     */
    setPasswordIcon() {
      //默认为关闭
      if (this.name == "accountPassword" || this.name == "password") {
        this.$set(this.item, "rightIcon", "closed-eye");
        this.$set(this.item, "type", "password");
      }
    },
    /**
     * @description  控制密码图标
     */
    onRightIcon() {
      if (this.name == "accountPassword" || this.name == "password") {
        const { rightIcon, type } = this.item;
        let icon = "",
          textType = "";
        rightIcon == "closed-eye" ? (icon = "eye-o") : (icon = "closed-eye");
        type == "password" ? (textType = "text") : (textType = "password");
        this.$set(this.item, "rightIcon", icon);
        this.$set(this.item, "type", textType);
      } else {
        this.$emit("iconEvent");
      }
    },
    /**
     * @description  输入框
     */
    onInput() {
      //禁止输入空格
      if (this.item.noTrim) {
        this.value = this.value.replace(/\s+/g, "");
      }
      //禁止输入中文
      if (this.item.noChinese) {
        this.value = this.value.replace(/[\u4E00-\u9FA5]/g, "");
      }
      this.$emit("clear");
      this.$emit("map", this.value);
    }
  }
};
</script>

<style lang="less" module>
.label {
  :global {
    .van-field__label {
      width: 0em !important;
    }
    .van-field__left-icon .van-icon,
    .van-field__right-icon .van-icon {
      line-height: 0.7rem;
      color: #dbdbdb;
    }
  }
}
.baseField {
  position: relative;
}
</style>
